import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Seo from "../components/Seo";
import ContactSection from "../components/ContactSection";

export default function Contact() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const defaultType = params.get("type") || "";

  useEffect(() => {
    if (location.hash === "#upload") {
      const t = setTimeout(() => {
        document.getElementById("upload")?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 400);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <>
      <Seo title="Contact Razor Build | Send Plans & Start Your Project — Wellington Builders" description="Tell Razor Build about your renovation, extension or new build. Upload plans and drawings directly — serving Wellington, Lower Hutt, Upper Hutt, Hutt Valley and Porirua." />
      <section className="pt-32 md:pt-40 pb-4 md:pb-6 bg-ink">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pb-10">
          <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-gold">Contact</p>
          <h1 className="mt-4 font-display font-bold text-4xl md:text-6xl tracking-tight text-white display-expanded leading-[1.0]">
            Let's Talk About<br />Your Project.
          </h1>
        </div>
      </section>
      <ContactSection defaultType={defaultType} />
    </>
  );
}
